import React, { Component } from 'react';
import FormModal from 'components/shared/modal/FormModal';
import PropTypes from 'prop-types';
import './AssignModal.css';
import SearchableDropDownPaginated from 'components/shared/dropdown/SearchableDropDownPaginated';
import Button from 'components/shared/button/Button';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import { generalContractorsApi } from 'services/api/general-contractors-api';

class AssignModal extends Component {
  static propTypes = {
    initialValues: PropTypes.shape({}),
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    initialValues: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedGc: props.initialValues.selectedGc,
      showConfirmationModal: false,
    };
  }

  loadGcs = (input, page) => {
    return generalContractorsApi
      .getGeneralContractors(page, null, input)
      .then((response) => {
        return {
          ok: true,
          options: response.generalContractors.data.map((gc) => {
            return {
              value: gc.id,
              label: gc.name,
            };
          }),
          hasMore: true,
        };
      });
  };

  handleSelect = (gc) => {
    this.setState({ selectedGc: gc });
  };

  handleConfirmation = (confirmation) => {
    if (confirmation) {
      const { onConfirm } = this.props;
      const { selectedGc } = this.state;
      onConfirm(selectedGc ? selectedGc.value : '');
    }

    this.setState({ showConfirmationModal: false });
  };

  render() {
    const { show, onClose } = this.props;
    const { selectedGc, showConfirmationModal } = this.state;
    return (
      <FormModal
        className="assign-select-gc-modal"
        show={show}
        title="Select General Contractor"
        onClose={onClose}
      >
        <div className="drop-down-container">
          <SearchableDropDownPaginated
            clearable
            value={selectedGc}
            loadOptions={(input, page) => this.loadGcs(input, page)}
            onChange={this.handleSelect}
          />
        </div>

        <Button
          className="button-orange"
          label="Confirm"
          onClick={() => this.setState({ showConfirmationModal: true })}
        />

        <ConfirmationModal
          show={showConfirmationModal}
          message="Are you sure?"
          onHide={this.handleConfirmation}
        />
      </FormModal>
    );
  }
}

export default AssignModal;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/transfer/AssignModal.js